// DO NOT REMOVE OR CHANGE THIS FILE. 
import * as Sentry from "@sentry/react";
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN_REACT,
  enabled: import.meta.env.VITE_SENTRY_ENABLED_REACT === "true" && Boolean(import.meta.env.VITE_SENTRY_DSN_REACT), 
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT_REACT || "development",
  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
  sendDefaultPii: true,
  integrations: [
    // If you're using react router, use the integration for your react router version instead.
    // Learn more at
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  // Enable logs to be sent to Sentry
  enableLogs: true,
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for tracing.
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
  tracesSampleRate: 0.1,
  // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
  tracePropagationTargets: [/^\//],
  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,
  // Stale dynamic-import chunks after a redeploy throw these errors. ErrorBoundary
  // already recovers via a full-page reload, so reporting them to Sentry adds noise
  // without actionable signal.
  ignoreErrors: [
    /Failed to fetch dynamically imported module/i,
    /Importing a module script failed/i,
    /ChunkLoadError/i,
    // Safari's wording for the same stale-chunk dynamic-import failure.
    /is not a valid JavaScript MIME type/i,
    // Safari: truncated/partially-cached lazy chunk parses as SyntaxError
    // instead of a MIME-type or fetch failure (GOFRANCHISE-WEB-B1).
    /Unexpected end of script/i,
    // Chrome: same truncated-chunk failure, wrapped in appendChild
    // (GOFRANCHISE-WEB-B0).
    /Failed to execute 'appendChild' on 'Node': Unexpected end of input/i,
    // Chrome: bare form of the same parse error (GOFRANCHISE-WEB-AZ).
    // Anchored so it does not swallow `Unexpected end of JSON input`.
    /^Unexpected end of input$/i,
    // Chrome's IndexedDB (LevelDB) backing store throws this when the user's local
    // disk is full — it comes from Firebase Auth's persistence layer writing to
    // IndexedDB in the background, not from any app code path. There's nothing we
    // can do server- or client-side about a user's disk being full, so it's noise.
    /FILE_ERROR_NO_SPACE/i,
  ],
});